import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { Message } from "../service/message.service";
import { RestService } from "../service/rest.service";
import { LoaderService } from "../service/loader.service";
import { HttpClient } from "@angular/common/http";
import { api } from "../../environments/environment";

@Component({
  selector: "app-import-notice-csv",
  template: ``,
  styles: [],
  standalone: false,
})
export class DownloadRequestsCSVComponent implements OnInit {
  @Input() fatherElement: any = {};
  @Input() fatherContaierRef: any;

  constructor(private host: ElementRef<HTMLElement>,private message:Message,private loader:LoaderService,private rest:RestService,private http:HttpClient) {}

  ngOnInit(): void {
    this.loader.on()
    this.http.get(`${api.baseUrl}/notice-admissibility-request/export`, {
      responseType: "blob",
      headers: {
        Authorization: `${api.prefixAuthorization} ${localStorage.getItem(
          'token'
        )}`,
      },
    }).subscribe((blob) => {
        const url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = "export.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        this.loader.off(true);
        this.autoDestory()
      });
  }

  autoDestory() {
    this.host.nativeElement.remove();
  }
}
